<!-- TODO: JULIUS rework naming convention for elements and cleanup html -->
<template>
  <aside id="nav-left">
    <router-link to="/advertisers">
      <div class="nav-left-logo" />
    </router-link>
    <div class="nav-left-advertiser_label">
      <router-link
        to="/advertisers"
      >
        <span v-if="this.advertiserReportingLabel && this.advertiserReportingLabel !== ''">
          {{this.advertiserReportingLabel}}
        </span>
        <span v-else>
          {{this.advertiserLabel}}
        </span>
      </router-link>
    </div>
    <div class="navList-title">PROFILE</div>
    <div class="navList-username">{{this.username}}</div>
    <div id="navList-wrapper">
      <div id="navList-container">
        <ul class="navList__left">
          <li class="navList__left__item">
            <div
              class="navList__left__subheading"
              v-on:click="logout()"
            >
              <span class="navList__left__subheading-icon navList__left__subheading-icon--logout"/>
              <span class="navList__left__subheading-title" >
                Logout
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="navList-title">CAMPAIGNS</div>
    <div id="navList-wrapper">
      <div id="navList-container">
        <ul class="navList__left">
          <template v-for="campaign in campaigns.slice().reverse()">
            <li class="navList__left__item">
              <div
                class="navList__left__subheading"
                v-on:click="campaign.clicked = !campaign.clicked"
              >
                <span
                  class="navList__left__subheading-icon"
                  v-bind:class="{ 'navList__left__subheading-icon--clicked': campaign.clicked }" />
                <span class="navList__left__subheading-title" v-if="campaign.reportingLabel && campaign.reportingLabel !== ''">
                  {{campaign.reportingLabel}}
                </span>
                <span class="navList__left__subheading-title" v-else>
                  {{campaign.label}}
                </span>
              </div>
              <ul class="subList" v-bind:class="{ subListHidden: !campaign.clicked }">
                <!-- TODO: JULIUS need to router-link these when we have partners and creatives -->
                <li class="subList__item">
                  <router-link
                    class="navList_link"
                    :to="{ name: 'campaignByLabel', params: { campaignLabel: campaign.label }}"
                  >
                    Overview
                  </router-link>
                </li>
<!--                 <li class="subList__item">partners</li>
                <li class="subList__item">creative</li> -->
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'nav-left',
  props: {
    advertiserLabel: String,
    advertiserReportingLabel: String,
    campaigns: Array,
  },
  data() {
    return {
      username: this.$store.state.user,
    };
  },
  methods: {
    logout() {
      this.$router.replace('/logout');
    },
  },
};
</script>

<style>

/* left nav with campaigns list */
#nav-left {
  position: absolute;
  top: 0;
  left: 0;
  padding: 51px 12px;
  height: 100%;
  width: 248px;
  background-color: #fff;
  color: #222;
  z-index: 1;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0.2px 0 20px 0px #ccc
}

.nav-left-advertiser_label {
  color: #360b2c;
  text-align: center;
  font-size: 24px;
  margin: 10px 0 21px 0;
  font-weight: 600;
}

/* campaigns list */
.navList__left {
  padding: 0;
  list-style-type: none;
  margin: 0 0 15px;
}

.navList__left__item {
  background-color: #f4f0f3;
  border-radius: 4px;
  padding: 8px;
  margin: 0 0 5px;
  box-shadow: 0 1.3px 0 #e4e4e4;
}

.navList__left__subheading {
  position: relative;
  font-weight: 600;
  text-transform: capitalize;
  text-align: left;
  font-size: 18px;
  line-height: 30px;
}

.navList__left__subheading-title {
  display: block;
  padding: 0 0 0px 21px;
  word-break: break-all;
}

.navList__left__subheading-icon {
  display: inline-block;
  position: absolute;
  top: 8px;
  height: 13px;
  width: 15px;
  background-image: url('~@/assets/icon/icon-12-megaphone-grey.svg');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all .3s ease;
}

.navList__left__subheading-icon--clicked {
  background-image: url('~@/assets/icon/icon-12-megaphone-purple.svg');
}

.navList__left__subheading-icon--logout {
  background-image: url('~@/assets/icon/icon-12-exit-purple.svg');
}

.navList__left .subList {
  list-style-type: none;
  visibility: visible;
  overflow: hidden;
  font-size: 15px;
  transition: all .3s ease-in-out;
  padding-top: 10px;
}

.navList__left .subList__item {
  text-transform: uppercase;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
}

.subList__item {
  padding-bottom: 1px;
  background-color: #eee8ec;
}

.navList__left__subheading:hover {
  cursor: pointer;
}

.navList__left .subListHidden {
  visibility: hidden;
  max-height: 0;
  padding: 0;
}
  
.navList_link {
  display: block;
  font-size: 15px;
  padding: 5px 20px;
  border-radius: 4px;
}

.navList_link:hover, 
.navList_link:focus, 
.navList_link.router-link-active {
  background-color: #fff;
  color: #4c123e;
  box-shadow: 0 1px 0 #e4e4e4;
}

.navList-title {
  color: #555555;
  line-height: 1.63;
  font-size: 16px;
  margin-bottom: 6px;
}

.navList-username {
  font-size: 13px;
  color: #4c123e;
  font-weight: 600;
  margin-bottom: 10px;
}

</style>
